import React from 'react';

import {PolicyStatement} from 'auth/PolicyConstants';
import {ItemTypeOptionNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import HelpButton from 'help/HelpButton';
import {Cell, Column, Table} from 'ui-library/simple-table/SimpleTable';

import ConditionDropdown from './ConditionDropdown';
import getActionRowDatas from './getActionRowDatas';

interface Props {
  isWritable: boolean;
  itemTypeOption: ItemTypeOptionNode;
  policyStatements: Array<PolicyStatement>;
  onUpdateStatements: (policyStatements: Array<PolicyStatement>) => void;
}

function DescriptionHelpButton(props: {description: string}): JSX.Element {
  return (
    <HelpButton
      renderContent={() => <div className="u-pre-wrap u-normal-font-weight">{props.description}</div>}
      iconClassName="u-mini-spacing-left"
    />
  );
}

function ItemTypeTable({
  isWritable,
  itemTypeOption,
  policyStatements,
  onUpdateStatements,
}: Props): JSX.Element | null {
  const actionRowDatas = getActionRowDatas(itemTypeOption.itemType, itemTypeOption.actionOptions);
  return (
    <div className="policyPage">
      <Table
        numRows={actionRowDatas.length}
        getRowClassName={(rowIndex: number): string =>
          actionRowDatas[rowIndex].level > 0 ? 'simpleTable-row--noShadow' : ''
        }
      >
        <Column
          header={
            <Cell>
              {itemTypeOption.name}
              {itemTypeOption.description && (
                <DescriptionHelpButton description={itemTypeOption.description} />
              )}
            </Cell>
          }
          renderCell={(rowIndex: number): JSX.Element => {
            const actionRowData = actionRowDatas[rowIndex];
            return (
              <Cell>
                <div style={{marginLeft: `${actionRowData.level * 20}px`}}>
                  {actionRowData.name}
                  {actionRowData.description && (
                    <DescriptionHelpButton description={actionRowData.description} />
                  )}
                </div>
              </Cell>
            );
          }}
        />
        <Column
          header={<Cell />}
          renderCell={(rowIndex: number): JSX.Element => (
            <Cell>
              <ConditionDropdown
                actionRowData={actionRowDatas[rowIndex]}
                policyStatements={policyStatements}
                onUpdateStatements={onUpdateStatements}
                isWritable={isWritable}
              />
            </Cell>
          )}
        />
      </Table>
    </div>
  );
}

export default ItemTypeTable;
